/*
  PELUX · Preuve sociale de la fiche produit — thème de test « page parfaite » (2026-10-14).
  Chargé sur les fiches par layout/theme.liquid, jamais depuis un snippet (un script réinjecté
  dans le DOM ne s'exécute pas). Trois éléments :
    <pelux-compte-a-rebours>  décompte d'une offre datée          (snippets/pelux-rebours.liquid)
    <pelux-avis-mur>          filtres et « Voir plus » du mur d'avis (snippets/pelux-temoignages.liquid)
    <pelux-stories>           visionneuse plein écran des stories    (snippets/pelux-temoignages.liquid)
  Et un comportement délégué : le rappel d'une édition limitée ([data-edition-ouvrir]) ouvre la
  carte de l'offre dans un <dialog> (snippets/pelux-edition.liquid, « Carte cachée… »).
  Les lots B ([data-pelux-lot]) ne sont pas traités à part : leur visibilité
  se joue en CSS, sur la classe html.pelux-lot-b posée par layout/theme.liquid.
*/
(function () {
  'use strict';

  var ESPACE = '\u00a0'; // espace insécable entre un nombre et son unité
  var DUREE_STORY = 6000; // ms — même durée que l'animation .pelux-story-vue__barre (pelux-preuve.css)

  /* ---------------------------------------------------------------------------
     Compte à rebours. La page est en cache chez Shopify : seul le navigateur connaît l'heure.
     Hors de la période [data-debut, data-fin], masque son conteneur [data-pelux-edition]
     (sauf [data-toujours] : lot du thème de test, toujours montré, qui affiche « terminée »).
     --------------------------------------------------------------------------- */
  if (!customElements.get('pelux-compte-a-rebours')) {
    customElements.define('pelux-compte-a-rebours', class extends HTMLElement {
      connectedCallback() {
        this.fin = Date.parse(this.dataset.fin || '');
        this.debut = Date.parse(this.dataset.debut || '');
        this.valeur = this.querySelector('[data-valeur]');
        this.cible = this.closest('[data-pelux-edition]');
        this.toujours = !!(this.cible && this.cible.hasAttribute('data-toujours'));
        if (isNaN(this.fin) || !this.valeur) {
          this.hidden = true;
          return;
        }
        this.tic = this.tic.bind(this);
        this.tic();
        clearInterval(this.minuterie);
        this.minuterie = setInterval(this.tic, 1000);
      }

      disconnectedCallback() {
        clearInterval(this.minuterie);
      }

      tic() {
        var maintenant = Date.now();
        var avant = !isNaN(this.debut) && maintenant < this.debut;
        var apres = maintenant >= this.fin;
        if (this.cible && !this.toujours) this.cible.hidden = avant || apres;
        if (apres) {
          this.valeur.textContent = this.dataset.termine || '';
          this.classList.add('is-termine');
          clearInterval(this.minuterie);
          return;
        }
        var reste = Math.floor((this.fin - maintenant) / 1000);
        var j = Math.floor(reste / 86400);
        var h = Math.floor((reste % 86400) / 3600);
        var m = Math.floor((reste % 3600) / 60);
        var s = reste % 60;
        var d = this.dataset;
        var deux = function (n) { return (n < 10 ? '0' : '') + n; };
        var texte;
        if (this.hasAttribute('data-court')) {
          texte = j > 0
            ? j + ESPACE + d.uJ + ' ' + deux(h) + ESPACE + d.uH
            : h + ESPACE + d.uH + ' ' + deux(m) + ESPACE + d.uMin;
        } else {
          texte = (j > 0 ? j + ESPACE + d.uJ + ' ' : '') +
            deux(h) + ESPACE + d.uH + ' ' + deux(m) + ESPACE + d.uMin + ' ' + deux(s) + ESPACE + d.uS;
        }
        if (this.valeur.textContent !== texte) this.valeur.textContent = texte;
      }
    });
  }

  /* ---------------------------------------------------------------------------
     Mur d'avis : filtres et révélation par lots. Le serveur rend déjà les cartes au-delà du
     premier lot en `hidden` (pas de saut de mise en page au chargement).
     Un filtre est un bouton [data-filtre] n'importe où dans l'élément (écoute par délégation :
     ceux qu'un script ajoute après coup répondent aussi) : « tous », « photos », ou
     « cle:valeur » — garde les cartes dont l'attribut data-cle contient le mot valeur
     (ex. note:3 → data-note="3" ; sujets:taille → data-sujets="taille confort", posé par
     assets/pelux-cro-avis.js). Un filtre actif se désactive au second appui (retour à « tous »).
     Chaque rendu émet « pelux:avis-rendu » (detail : filtre, eligibles, visibles).
     --------------------------------------------------------------------------- */
  if (!customElements.get('pelux-avis-mur')) {
    customElements.define('pelux-avis-mur', class extends HTMLElement {
      connectedCallback() {
        if (this.pret) return;
        this.pret = true;
        var self = this;
        this.parLot = parseInt(this.dataset.parLot, 10) || 4;
        this.parClic = parseInt(this.dataset.parClic, 10) || this.parLot;
        this.limite = this.parLot;
        this.filtre = 'tous';
        this.cartes = Array.prototype.slice.call(this.querySelectorAll('[data-avis-carte]'));
        this.plus = this.querySelector('[data-plus]');
        this.statut = this.querySelector('[data-statut]');
        this.addEventListener('click', function (e) {
          var bouton = e.target.closest ? e.target.closest('[data-filtre]') : null;
          if (!bouton || !self.contains(bouton) || bouton.disabled) return;
          var filtre = bouton.dataset.filtre;
          self.filtre = filtre === self.filtre && filtre !== 'tous' ? 'tous' : filtre;
          self.limite = self.parLot;
          self.rendre(false);
        });
        if (this.plus) {
          this.plus.addEventListener('click', function () {
            self.limite += self.parClic;
            self.rendre(true);
          });
        }
        this.rendre(false);
      }

      correspond(carte) {
        var filtre = this.filtre;
        if (filtre === 'tous') return true;
        if (filtre === 'photos') return carte.dataset.photo === '1';
        var i = filtre.indexOf(':');
        if (i < 1) return true;
        var valeur = carte.dataset[filtre.slice(0, i)];
        return !!valeur && (' ' + valeur + ' ').indexOf(' ' + filtre.slice(i + 1) + ' ') !== -1;
      }

      rendre(donnerFocus) {
        var self = this;
        var visibles = 0;
        var premierNouveau = null;
        var eligibles = this.cartes.filter(function (c) { return self.correspond(c); });
        this.cartes.forEach(function (c) { c.hidden = true; });
        eligibles.forEach(function (c, i) {
          if (i >= self.limite) return;
          c.hidden = false;
          visibles += 1;
          if (donnerFocus && i === self.limite - self.parClic) premierNouveau = c;
        });
        Array.prototype.forEach.call(this.querySelectorAll('[data-filtre]'), function (b) {
          b.setAttribute('aria-pressed', String(b.dataset.filtre === self.filtre));
        });
        if (this.plus) this.plus.hidden = eligibles.length <= this.limite;
        if (this.statut) this.statut.textContent = (this.dataset.modeleStatut || '').replace('[n]', visibles);
        if (premierNouveau) {
          premierNouveau.setAttribute('tabindex', '-1');
          premierNouveau.focus({ preventScroll: true });
        }
        this.dispatchEvent(new CustomEvent('pelux:avis-rendu', {
          detail: { filtre: this.filtre, eligibles: eligibles.length, visibles: visibles }
        }));
      }
    });
  }

  /* ---------------------------------------------------------------------------
     Stories : la vignette ouvre une visionneuse plein écran (<dialog> natif : Échap, focus
     rendu à la vignette). Une story dure 6 s, appui long = pause, glisser à gauche / à droite =
     suivante / précédente, glisser vers le bas = fermer. Mouvement réduit demandé : pas de
     défilement automatique.
     ⚠️ Le passage à la suivante est minuté en JS (DUREE_STORY), PAS sur `animationend` de la barre :
     WebKit a rendu cet événement au bout de moins d'une seconde (banc du 2026-10-14) — la barre
     animée en CSS n'est plus qu'un affichage, gelée en même temps que le minuteur.
     --------------------------------------------------------------------------- */
  if (!customElements.get('pelux-stories')) {
    customElements.define('pelux-stories', class extends HTMLElement {
      connectedCallback() {
        if (this.pret) return;
        this.pret = true;
        var self = this;
        this.items = Array.prototype.slice.call(this.querySelectorAll('[data-story]'));
        this.vue = this.querySelector('[data-story-vue]');
        if (!this.vue || !this.items.length || typeof this.vue.showModal !== 'function') return;
        this.media = this.vue.querySelector('[data-story-media]');
        this.texte = this.vue.querySelector('[data-story-texte]');
        this.barres = this.vue.querySelector('[data-story-barres]');
        this.position = this.vue.querySelector('[data-story-position]');
        this.btnPause = this.vue.querySelector('[data-story-pause]');
        this.cadre = this.vue.querySelector('.pelux-story-vue__cadre');
        this.reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.index = 0;
        if (this.reduit && this.btnPause) this.btnPause.hidden = true;

        this.items.forEach(function () {
          var barre = document.createElement('span');
          barre.className = 'pelux-story-vue__barre';
          barre.appendChild(document.createElement('span'));
          self.barres.appendChild(barre);
        });
        this.items.forEach(function (li, i) {
          var bouton = li.querySelector('[data-story-ouvrir]');
          if (bouton) bouton.addEventListener('click', function () { self.ouvrir(i, bouton); });
        });

        this.vue.querySelector('[data-story-prec]').addEventListener('click', function () {
          if (self.sansClic()) return;
          self.aller(self.index - 1);
        });
        this.vue.querySelector('[data-story-suiv]').addEventListener('click', function () {
          if (self.sansClic()) return;
          self.aller(self.index + 1);
        });
        // Appui n'importe où dans la story, texte compris (comme sur Instagram) : tiers gauche =
        // précédente, le reste = suivante. Les zones-boutons restent pour le clavier.
        this.cadre.addEventListener('click', function (e) {
          if (e.target.closest('.pelux-story-vue__commandes, [data-story-prec], [data-story-suiv], a, summary')) return;
          if (self.sansClic()) return;
          var r = self.cadre.getBoundingClientRect();
          self.aller(self.index + (e.clientX - r.left < r.width * 0.32 ? -1 : 1));
        });
        this.vue.querySelector('[data-story-fermer]').addEventListener('click', function () { self.vue.close(); });
        if (this.btnPause) this.btnPause.addEventListener('click', function () { self.pause(!self.enPause); });
        this.vue.addEventListener('close', function () { self.fermer(); });
        this.vue.addEventListener('click', function (e) { if (e.target === self.vue) self.vue.close(); });
        this.vue.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); self.aller(self.index + 1); }
          else if (e.key === 'ArrowLeft') { e.preventDefault(); self.aller(self.index - 1); }
        });
        // Appui long : pause le temps de lire, comme une story.
        this.cadre.addEventListener('pointerdown', function (e) {
          if (e.target.closest('.pelux-story-vue__commandes')) return;
          if (!self.enPause) { self.pauseTemporaire = true; self.pause(true); }
        });
        ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (type) {
          self.cadre.addEventListener(type, function () {
            if (self.pauseTemporaire) { self.pauseTemporaire = false; self.pause(false); }
          });
        });

        // Glissés au doigt.
        var x0 = null;
        var y0 = null;
        this.cadre.addEventListener('touchstart', function (e) {
          x0 = e.touches[0].clientX;
          y0 = e.touches[0].clientY;
        }, { passive: true });
        this.cadre.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          var dy = e.changedTouches[0].clientY - y0;
          x0 = null;
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
            self.clicIgnoreJusqua = Date.now() + 400;
            self.aller(self.index + (dx < 0 ? 1 : -1));
          } else if (dy > 90 && dy > Math.abs(dx)) {
            self.clicIgnoreJusqua = Date.now() + 400;
            self.vue.close();
          }
        }, { passive: true });
      }

      sansClic() {
        return this.clicIgnoreJusqua && Date.now() < this.clicIgnoreJusqua;
      }

      ouvrir(i, declencheur) {
        this.declencheur = declencheur;
        document.documentElement.classList.add('pelux-story-ouverte');
        this.vue.showModal();
        this.pause(false);
        this.aller(i);
      }

      aller(i) {
        if (i < 0) i = 0;
        if (i >= this.items.length) {
          this.vue.close();
          return;
        }
        this.index = i;
        var li = this.items[i];

        this.media.textContent = '';
        var vignette = li.querySelector('img');
        if (vignette || li.dataset.grand) {
          var image = document.createElement('img');
          image.className = 'pelux-story-vue__img';
          image.alt = vignette ? vignette.alt : '';
          image.src = li.dataset.grand || vignette.currentSrc || vignette.src;
          image.decoding = 'async';
          this.media.appendChild(image);
        }

        this.texte.textContent = '';
        var detail = li.querySelector('template[data-story-detail]');
        if (detail) this.texte.appendChild(detail.content.cloneNode(true));

        var barres = this.barres.children;
        for (var k = 0; k < barres.length; k++) {
          barres[k].classList.toggle('is-vue', k < i);
          barres[k].classList.remove('is-active');
        }
        void this.barres.offsetWidth; // relance l'animation de la barre courante
        if (barres[i]) barres[i].classList.add(this.reduit ? 'is-vue' : 'is-active');
        this.minuter(DUREE_STORY);

        if (this.position) {
          this.position.textContent = (this.position.dataset.modele || '')
            .replace('[n]', i + 1)
            .replace('[total]', this.items.length);
        }
      }

      minuter(duree) {
        var self = this;
        clearTimeout(this.minuterie);
        this.reste = duree;
        this.depart = Date.now();
        if (this.reduit || this.enPause || !this.vue.open) return;
        this.minuterie = setTimeout(function () { self.aller(self.index + 1); }, duree);
      }

      pause(oui) {
        if (oui && !this.enPause) {
          clearTimeout(this.minuterie);
          this.reste = Math.max(0, (this.reste || DUREE_STORY) - (Date.now() - (this.depart || Date.now())));
        }
        var reprendre = !oui && this.enPause;
        this.enPause = oui;
        if (reprendre && this.vue.open) this.minuter(this.reste || DUREE_STORY);
        this.vue.classList.toggle('is-pause', oui);
        if (!this.btnPause) return;
        this.btnPause.setAttribute('aria-pressed', String(oui));
        this.btnPause.setAttribute('aria-label', oui ? this.btnPause.dataset.libelleLecture : this.btnPause.dataset.libellePause);
      }

      fermer() {
        clearTimeout(this.minuterie);
        document.documentElement.classList.remove('pelux-story-ouverte');
        var barres = this.barres.children;
        for (var k = 0; k < barres.length; k++) barres[k].classList.remove('is-active', 'is-vue');
        this.media.textContent = '';
        this.pauseTemporaire = false;
        if (this.declencheur) this.declencheur.focus();
      }
    });
  }

  /* ---------------------------------------------------------------------------
     Édition limitée : le rappel sous le prix, devenu bouton, ouvre la carte de l'offre dans un
     <dialog> natif (Échap et focus gérés par le navigateur). Délégation sur le document : le
     bloc Prix est re-rendu à chaque changement de variante, le bouton est alors remplacé.
     Fermeture : bouton ×, Échap, ou appui sur le fond assombri.
     Bouton de la carte vers une ancre de la fiche ([data-edition-vers], ex. l'offre duo
     #pelux-duo) : la carte se ferme SANS rendre le focus au rappel — il ferait remonter la page —,
     puis la page descend jusqu'à l'ancre, brièvement cerclée. Avec [data-edition-ajouter] (réglage
     « Le bouton ajoute l'offre au panier ») : la carte se ferme et le bouton d'ajout de l'ancre
     ([data-pack-add], assets/pelux-pack.js) est actionné — le duo part au panier.
  --------------------------------------------------------------------------- */
  if (!window.peluxEditionCarte) {
    window.peluxEditionCarte = true;
    document.addEventListener('click', function (e) {
      var cible = e.target;
      if (!cible || !cible.closest) return;
      var ouvrir = cible.closest('[data-edition-ouvrir]');
      if (ouvrir) {
        var carte = document.getElementById(ouvrir.getAttribute('aria-controls'));
        if (!carte || typeof carte.showModal !== 'function' || carte.open) return;
        carte.showModal();
        ouvrir.setAttribute('aria-expanded', 'true');
        carte.addEventListener('close', function () {
          ouvrir.setAttribute('aria-expanded', 'false');
          if (carte.peluxSansRetour) {
            carte.peluxSansRetour = false;
            return;
          }
          if (ouvrir.isConnected) ouvrir.focus({ preventScroll: true });
        }, { once: true });
        return;
      }
      var vers = cible.closest('[data-edition-vers]');
      if (vers) {
        var boite = vers.closest('dialog');
        var destination = null;
        try {
          destination = document.querySelector(vers.getAttribute('href'));
        } catch (err) {
          destination = null; // une adresse, pas une ancre : lien ordinaire
        }
        if (!boite || !destination) return;
        e.preventDefault();
        boite.peluxSansRetour = true;
        boite.close();
        var ajout = vers.hasAttribute('data-edition-ajouter') ? destination.querySelector('[data-pack-add]') : null;
        if (ajout) {
          ajout.click();
          return;
        }
        var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        destination.scrollIntoView({ behavior: reduit ? 'auto' : 'smooth', block: 'center' });
        if (!destination.hasAttribute('tabindex')) destination.setAttribute('tabindex', '-1');
        destination.focus({ preventScroll: true });
        destination.classList.add('pelux-vise');
        setTimeout(function () { destination.classList.remove('pelux-vise'); }, 1800);
        return;
      }
      if (cible.closest('[data-edition-fermer]')) {
        var dialogue = cible.closest('dialog');
        if (dialogue) dialogue.close();
        return;
      }
      // Appui sur le fond : la cible est le <dialog> lui-même (son contenu remplit le cadre).
      if (cible.matches('dialog.pelux-edition-dialog')) cible.close();
    });
  }
})();
